<div class="overflow-y-auto max-h-[80vh] relative bg-white w-full max-w-6xl flex flex-col">
  <!-- Header with Close Button -->
  <div class="sticky top-0 bg-white z-10 p-4 border-b flex justify-between items-center">
    <h2 class="text-2xl font-bold text-gray-800">Interactive Seat Map</h2>
    <button 
      mat-icon-button 
      class="text-gray-500 hover:bg-gray-100 rounded-full"
      (click)="close()" 
      aria-label="Close"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Main Content -->
  <div class="w-full p-6 overflow-y-auto">
    <!-- Venue Image at Top -->
    <div class="mb-8 max-w-2xl  rounded-lg overflow-hidden shadow-md">
      <img 
        src="https://ssearenabelfast.s3.amazonaws.com/ARENA_MAPS_5LOS-03.png" 
        alt="Venue Overview" 
        class="w-full h-auto object-cover"
      >
    </div>

    <!-- Legend -->
    <div class="flex flex-wrap justify-center gap-4 mb-8">
      <div class="flex items-center gap-2 px-3 py-1 bg-gray-100 rounded-full">
        <div class="w-4 h-4 bg-cyan-400 rounded-sm"></div>
        <span class="text-sm font-medium">Available</span>
      </div>
      <div class="flex items-center gap-2 px-3 py-1 bg-gray-100 rounded-full">
        <div class="w-4 h-4 bg-green-500 rounded-sm"></div>
        <span class="text-sm font-medium">Selected</span>
      </div>
      <div class="flex items-center gap-2 px-3 py-1 bg-gray-100 rounded-full">
        <div class="w-4 h-4 bg-purple-600 rounded-sm"></div>
        <span class="text-sm font-medium">Disabled Access</span>
      </div>
    </div>

    <!-- Stadium Layout Container -->
    <div class="w-full bg-indigo-900 rounded-2xl p-4 md:p-8 mx-auto">
      <!-- Center Floor Standing -->
      <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 hidden">
        <div class="bg-cyan-500 text-white px-6 py-10 rounded-lg flex items-center justify-center shadow-lg">
          <span class="text-lg font-semibold">FLOOR STANDING</span>
        </div>
      </div>

      <!-- Stage (Right Side) -->
      <div class="absolute right-4 top-1/2 transform -translate-y-1/2 hidden">
        <div class="bg-pink-500 text-white px-3 py-12 rounded-lg flex items-center justify-center shadow-lg">
          <span class="text-lg font-semibold transform rotate-90">STAGE</span>
        </div>
      </div>

      <!-- Grid Layout for Seats -->
      <!-- Stadium Layout: 4 Columns for N / W / E / S -->
<div class="grid grid-cols-4 gap-4 text-white">
  <!-- North Section -->
  <div>
    <h4 class="text-center mb-2 text-sm font-semibold">NORTH</h4>
    <div class="grid grid-cols-4 gap-2 justify-center">
      <!-- Top row D17-D22 -->
      <div *ngFor="let seat of northTopSeats"
           [class]="getSeatClasses(seat)"
           (click)="onSeatClick(seat)"
           (mouseenter)="onSeatHover(seat)"
           (mouseleave)="onSeatLeave()">
        {{ seat }}
      </div>
    </div>
    <!-- NU / NM / NL -->
    <div *ngFor="let row of ['NU', 'NM', 'NL']" class="grid grid-cols-3 gap-2 mt-2">
      <div *ngFor="let seat of seatSections[row]"
           [class]="getSeatClasses(seat)"
           (click)="onSeatClick(seat)"
           (mouseenter)="onSeatHover(seat)"
           (mouseleave)="onSeatLeave()">
        {{ seat }}
      </div>
    </div>
  </div>

  <!-- West Section -->
  <div>
    <h4 class="text-center mb-2 text-sm font-semibold  origin-bottom">WEST</h4>
    <div class="grid grid-cols-4 gap-2 justify-center">
      <ng-container *ngFor="let seatGroup of westSeatGroups">
        <div *ngFor="let seat of seatGroup"
             [class]="getSeatClasses(seat)"
             (click)="onSeatClick(seat)"
             (mouseenter)="onSeatHover(seat)"
             (mouseleave)="onSeatLeave()">
          {{ seat }}
        </div>
      </ng-container>
    </div>
  </div>

  <!-- East Section -->
  <div>
    <h4 class="text-center mb-2 text-sm font-semibold  origin-bottom">EAST</h4>
    <div class="grid grid-cols-4 gap-2 justify-center">
      <ng-container *ngFor="let seatGroup of eastSeatGroups">
        <div *ngFor="let seat of seatGroup"
             [class]="getSeatClasses(seat)"
             (click)="onSeatClick(seat)"
             (mouseenter)="onSeatHover(seat)"
             (mouseleave)="onSeatLeave()">
          {{ seat }}
        </div>
      </ng-container>
    </div>
  </div>

  <!-- South Section -->
  <div>
    <h4 class="text-center mb-2 text-sm font-semibold">SOUTH</h4>
    <div *ngFor="let row of ['SU', 'SM', 'SL']" class="grid grid-cols-4 gap-2 mb-2">
      <div *ngFor="let seat of seatSections[row].slice().reverse()"
           [class]="getSeatClasses(seat)"
           (click)="onSeatClick(seat)"
           (mouseenter)="onSeatHover(seat)"
           (mouseleave)="onSeatLeave()">
        {{ seat }}
      </div>
    </div>
    <!-- Bottom row D5-D10 -->
    <div class="grid grid-cols-3 gap-2">
      <div *ngFor="let seat of southBottomSeats"
           [class]="getSeatClasses(seat)"
           (click)="onSeatClick(seat)"
           (mouseenter)="onSeatHover(seat)"
           (mouseleave)="onSeatLeave()">
        {{ seat }}
      </div>
    </div>
  </div>
</div>

    </div>

    <!-- Selected Seats Panel -->
    <div class="mt-8 p-4 bg-gray-50 rounded-lg border">
      <h3 class="font-semibold text-lg mb-3">Selected Seats ({{ getSelectedSeatsCount() }})</h3>
      <div class="flex flex-wrap gap-2 min-h-10">
        <span *ngFor="let seat of getSelectedSeatsArray()" 
              class="bg-green-500 text-white px-3 py-1 rounded-full text-sm flex items-center">
          {{ seat }}
          <button 
            (click)="onSeatClick(seat)" 
            class="ml-1 text-white hover:bg-green-600 rounded-full w-4 h-4 flex items-center justify-center"
          >
            ×
          </button>
        </span>
        <p *ngIf="getSelectedSeatsCount() === 0" class="text-gray-500 text-sm">
          Click on seats to select them
        </p>
      </div>
    </div>
  </div>
</div>